<template>
	<!-- 宿舍管理-->
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
			<el-form @keyup.native.enter="inquiryClick">
				<el-row class="top-first-line">
					<el-col :span="5">
						<el-form-item label="名称:">
							<el-input v-model="Dform.name" placeholder='请输入名称'></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<!-- <el-form-item label="楼栋:">
							<el-input v-model="Dform.name" placeholder='请选择楼栋'></el-input>
						</el-form-item> -->
						<el-form-item label="楼栋:">
							<!-- <el-input v-model="Dform.schoolName" placeholder=''></el-input> -->
							<el-select v-model="schoolListTopId" placeholder="请选择楼栋" @change="LouDongBtn">
								<el-option :label="item.name" :value="item.id" v-for="item in LouData"
									:key="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
					<el-button type="primary" @click="AddDormitoriesClick()">新增宿舍</el-button>
					<el-button style="background-color: red; color: #fff;" @click="DtlConfirmBtn()">删除</el-button>
					<!-- <el-button type="primary" class="query-button" @click="addLouDong">新增</el-button> -->


				</el-row>

			</el-form>
		</div>


		<!-- table表格 -->
		<div class="Table-Bottom">
			<el-table v-loading="loading" stripe :border="true"
				:header-cell-style="{ background: '#EDF6FF', color: '#000', height: '40px' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" label="序号" width="100">
				</el-table-column>

				<el-table-column prop="name" label="房间名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="buildingName" label="归属楼栋" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="studentCount" label="当前房间人数" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="created" label="添加时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="清空宿舍" show-overflow-tooltip>
					<template #default="scope">

						<el-button @click="ConfirmClearPeople(scope.row)">清空宿舍</el-button>
					</template>

				</el-table-column>

				<el-table-column label="操作" min-width="100">
					<template #default="scope">
						<el-button class="textButton" type="text" size="small"
							@click="alterAdd(scope.row)">添加人数</el-button>
						<!-- <el-button class="textButton" type="text" size="small" @click="statusClick(scope.row)" v-if="scope.row.status == 1">加入黑名单</el-button> -->
						<el-button class="shanchuBtn" type="text" @click="DtlConfirmBtn(scope.row)">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- <div style="margin-top: 20px">
				<el-button @click="deleteClick">批量删除</el-button>
			</div> -->

			<div class="block-fenye">
				<el-pagination :small="small" :disabled="disabled" :background="background"
					layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>
		<!-- <div  class="tankuang" > -->
		<AddIndex v-if="AddIndexShow" @handleClose='handleClose'></AddIndex>
		<!-- </div> -->
		<AddPeople v-if="AddPeopleShow" :alterAddItem="alterAddItem" @AddPeopleHandle='AddPeopleHandle'></AddPeople>
	</div>
</template>
<!--  -->
<script>
	import {
		SusheDormitoryList,
		LoDongBuildingList,
		DormitoryClearSushe,
		dormitoryDelete
	} from '@/assets/api/schoollog.js'
	import {
		findTeacherInfo,
	} from '@/assets/api/renyuan';
	import AddIndex from './group/addIndex.vue';
	import AddPeople from './group/addPeople.vue';
	export default {
		components: {
			AddIndex,
			AddPeople
		},
		data() {
			return {

				Dform: {
					name: ''
				},

				pageInfo: {
					page: 1,
					pageSize: 10,
				},
				multipleSelection: [],
				LouData: [],
				schoolInfo: {},
				tableData: [],
				total: 0,
				twigMax: 0,
				twigMin: 0,
				schoolListTopId: '',
				deleteList: [],
				AddIndexShow: false,
				AddPeopleShow: false,
				alterAddItem: {}
			}
		},
		created() {
			this.Lookteacher()
			// this.menuGetUserTreeGet()
		},
		methods: {
			AddPeopleHandle() {
				this.AddPeopleShow = false
				this.Lookteacher()

			},
			alterAdd(item) {
				console.log(item, '添加人员1111');
				this.alterAddItem = item
				this.AddPeopleShow = true
			},
			AddDormitoriesClick() {
				if (this.schoolInfo.schoolId) {
					this.AddIndexShow = true

				} else {
					this.$message({
						message: '该账号没有权限，请登录学校账号！',
						type: 'warning'
					});
				}
			},
			handleClose() {
				this.AddIndexShow = false
				console.log('关闭新增');
				this.Lookteacher()
			},
			handleSelectionChange(val) {
				console.log(val, '多选');
				this.deleteList = val
			},
			deleteClick(item) {
				let list = []
				if (item) {
					list.push(item.id)
				} else if (this.deleteList.length) {
					this.deleteList.forEach((value) => {
						list.push(value.id)
					})
				}
				if (!list.length) {
					this.$message({
						type: 'error',
						message: '请选择要删除的数据！'
					});
					return
				}
				dormitoryDelete({
					ids: list
				}).then((res) => {
					this.Lookteacher()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg || '接口异常'
					});
				});
			},
			DtlConfirmBtn(item) {
				if (this.schoolInfo.schoolId) {
					this.$confirm('请确认是否删除选中数据!', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.deleteClick(item)
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg || '接口异常'
						});
					});
				} else {
					this.$message({
						message: '该账号没有权限，请登录学校账号！',
						type: 'warning'
					});
				}
			},
			
			// 查看学校id 
			Lookteacher() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					this.schoolInfo = res.data.data
					this.getList()
					this.handleChange()
				}).catch((err) => {
					console.log(err);
				})
			},
			//列表
			getList() {
				let params = {
					buildingId: this.schoolListTopId,
					schoolId: this.schoolInfo.schoolId,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
				}
				SusheDormitoryList(params).then((res) => {
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				}).catch((err) => {
					console.log(err);
				})

			},
			//楼栋下拉列表
			handleChange() {
				console.log('1ppppp');

				let params = {
					schoolId: this.schoolInfo.schoolId,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: '9999',
				}
				LoDongBuildingList(params).then((res) => {
					this.LouData = res.data.data.list

				}).catch((err) => {
					console.log(err);
				})
			},
			//清空宿舍
			ClearSushe(item) {
				DormitoryClearSushe(item.id).then((res) => {
					this.getList()
				}).catch((err) => {
					console.log(err);
				})
			},

			ConfirmClearPeople(item) {
				this.$confirm('请确认是否清除该房间人数!', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.ClearSushe(item)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg || '接口异常'
					});
				});
			},

			LouDongBtn() {
				this.getList()
			},
			inquiryClick() {
				// this.pageInfo.page = 1
				this.getList()
			},


			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.getList()
			},

		}
	}
</script>

<!-- porimse -->
<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 40px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 95%;
		background-color: #fff;
		border-radius: 8px;

		.fuzzy-matching-top {
			// height: 120px ;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-button--small {
						width: 50px;
						height: 30px;
						margin-left: 20px;
						margin-top: 3px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}


			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 800px;
					// padding: 16px 24px;
					width: 50px;
					height: 50px !important;
					// top: 50%;
					// transform: translate(0,-50%);
				}
			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

			}

			.el-button--text {
				margin-left: 50px;
				margin-top: 10px;
				font-size: 16px;
			}
		}

		.block-fenye {
			// float: right;
			position: absolute;
			//   bottom: 0px;
			right: 10%;
			top: 85%;
			transform: translate(-50%, 0);

		}

		.Table-Bottom {
			height: calc(100% - 30px);
			overflow: auto;
			// position: relative;
			padding: 0px 20px;
			padding-top: 20px;
			// margin-top: 15px;
			border-radius: 8px;

			:deep() {
				.el-table .cell {
					// font-size: 15px;
					font-size: 16px;
					color: black;
					// font-weight: 700;
					text-align: center;
					height: 30px;
					line-height: 30px;
				}

				.el-table th.el-table__cell>.cell {
					font-weight: 700;
				}
			}

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;

			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}
		}


		:deep(.el-dialog) {
			width: 700px;
		}
	}
</style>